(() => {
  /*
  const readATCPlpOptimization = () => {
    const holdoutGroup = window._growthbook.getFeatureValue(
      "noah-holdout-group",
      "OFF",
    );
    const featureFlag = window._growthbook.getFeatureValue(
      "pdm-atc-plp-optimization",
      false,
    );
    const enabled = holdoutGroup !== "holdout-q3-2026";
    if (enabled && featureFlag) {
      document.body.setAttribute("atc-plp", "B");
    }
  };
  */

  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(() => {
    const applyFeatureFlags = () => {
      //readATCPlpOptimization();
    };

    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
})();
